class PusherController extends AbstractController
	@register()
	@inject 'CredentialsManager',
		'PUSHER_KEY'
		'PUSHER_CLUSTER'
		'ENV'
		'Guid'
		'PusherRepository'
		'ToastService'

	initialize: ->
		Pusher.logToConsole = true

		@subscriptions = []
		@shop = null
		@channelName = null
		@order = {
			order_id: null
			register_id: null
			device_id: @getDeviceId()
			channel_name: "presence-#{@ENV.tenant}-#{@ENV.environment}-orders-???"
			users: []
		}

		@tabs = [
			{
				selector: '#tab-device-status'
				title: 'Device Status'
			}
			{
				selector: '#tab-preorder-status'
				title: 'Preorder Status'
			}
		]

	setOrderChannelName: ->
		tenant = @ENV.tenant

		if tenant == 'infra'
			tenant = 'wallmob'

		@order.channel_name = "presence-#{tenant}-#{@ENV.environment}-orders-#{@order.order_id}"

	addSubscription: ->
		@subscriptions.push({
			device_id: @getDeviceId()
			shop_id: null
			shop_name: null
			register_id: null
			register_name: null
			client: null
			channel_name: @channelName
		})

	getDeviceId: ->
		return 'WBO-' + @Guid.generate().substring(4)

	setChannelName: (shop) ->
		@shop = shop

		@PusherRepository
			.listChannels(@shop.id)
			.then (channels) =>
				@channelName = channels[@shop.id]

				@addSubscription()

	subscribe: (subscription) ->
		if subscription.client?
			@unsubscribe(subscription)

			return

		payload =
			shop_id: @shop?.id
			device_id: subscription.device_id
			register_id: subscription.register_id

		for key, value of payload
			if !value?
				delete payload[key]

		subscription.loading = true
		subscription.client = new Pusher(
			@PUSHER_KEY,
			{
				cluster: @PUSHER_CLUSTER
				channelAuthorization:
					endpoint: @PusherRepository.getAuthUrl()
					params: payload
					headers:
						Authorization: "Bearer #{@CredentialsManager.getAccessToken()}"
			}
		)

		channel = subscription.client.subscribe(subscription.channel_name)
		channel.bind 'pusher:subscription_error',
			(status) =>
				subscription.loading = false
				@unsubscribe(subscription)
				@ToastService.add(status.error, 'Pusher', 'Server error', 'error')
		channel.bind 'pusher:subscription_succeeded',
			=>
				subscription.loading = false

				if subscription.users?
					subscription.users = Object.values(channel.members.members)

	unsubscribe: (subscription) ->
		subscription
			.client
			.unsubscribe(subscription.channel_name)
		delete subscription.client

		if subscription.users?
			subscription.users = []
